export const DRAWER_WIDTH_OPENED = 257;
export const DRAWER_WIDTH_CLOSED = 57;
export const FILTER_DRAWER_WIDTH = 257;